

export class PoiTypeUpdateUpdateInput implements IPoiTypeUpdateUpdateInput {
    /** The auto-generated id of the poi type master */
    poiTypeId!: number;
    /** The Poi type name with 255 character limit */
    poiTypeName!: string;

    constructor(data?: IPoiTypeUpdateUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poiTypeId = _data["poiTypeId"];
            this.poiTypeName = _data["poiTypeName"];
        }
    }

    static fromJS(data: any): PoiTypeUpdateUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new PoiTypeUpdateUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poiTypeId"] = this.poiTypeId;
        data["poiTypeName"] = this.poiTypeName;
        return data; 
    }
}

export interface IPoiTypeUpdateUpdateInput {
    /** The auto-generated id of the poi type master */
    poiTypeId: number;
    /** The Poi type name with 255 character limit */
    poiTypeName: string;
}

